export enum GoogleTagManagerEventEnum {
    interaction = 'interaction',
    screenView = 'screen_view',
    noInteraction = 'nointeraction'
}